import { createClient } from '@supabase/supabase-js';

const getSupabaseUrl = () => {
    // Для Vite (import.meta.env)
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env.VITE_SUPABASE_URL;
    }
    return;
};

const getSupabaseAnonKey = () => {
    // Для Vite
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env.VITE_SUPABASE_ANON_KEY;
    }
    return;
};

const TASK_FUNCTION_URL = `${getSupabaseUrl()}/functions/v1/task-management`;

const supabase = createClient(getSupabaseUrl(), getSupabaseAnonKey());

export { supabase };

interface Task {
    id: string;
    title: string;
    description?: string;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    due_time?: string;
    category?: string;
    assignee?: string;
    progress: number;
    details?: string;
    notes?: string;
    related_case?: string;
    tags?: string[];
    estimated_hours?: number;
    created_at: string;
    updated_at: string;
}

interface CreateTaskInput {
    title: string;
    description?: string;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    due_time?: string;
    category?: string;
    assignee?: string;
    progress?: number;
    details?: string;
    notes?: string;
    related_case?: string;
    tags?: string[];
    estimated_hours?: number;
    clerkUserId?: string;
    organizationId?: string;
    user_id?: string;
}

async function callTaskFunction(action: string, payload: any = {}) {
    console.log('Calling task function:', action, payload);

    const { data, error } = await supabase.functions.invoke('task-management', {
        body: {
            action,
            ...payload
        }
    });

    if (error) {
        console.error('Task function error:', error);
        throw new Error(error.message || 'Task operation failed');
    }

    if (!data || (data.error && !data.ok)) {
        throw new Error(data?.error || 'Task operation failed');
    }

    return data;
}

export async function createTask(task: CreateTaskInput, organizationId?: string, clerkUserId?: string): Promise<Task> {
    const result = await callTaskFunction('create_task', {
        task,
        organizationId,
        clerkUserId,
    });
    return result.task;
}

export async function getTasks(organizationId?: string, clerkUserId?: string): Promise<Task[]> {
    console.log(clerkUserId)
    const result = await callTaskFunction('get_tasks', { organizationId, clerkUserId });
    return result.tasks;
}

export async function getTaskById(taskId: string, clerkUserId?: string): Promise<Task> {
    const result = await callTaskFunction('get_task_by_id', { taskId });
    return result.task;
}

export async function updateTask(taskId: string, updates: Partial<CreateTaskInput>, clerkUserId?: string): Promise<Task> {
    console.log(clerkUserId)
    const result = await callTaskFunction('update_task', { taskId, updates, clerkUserId });
    return result.task;
}

export async function deleteTask(taskId: string, clerkUserId?: string): Promise<boolean> {
    await callTaskFunction('delete_task', { taskId });
    return true;
}

export async function updateTaskProgress(taskId: string, progress: number, clerkUserId?: string): Promise<Task> {
    const result = await callTaskFunction('update_task_progress', { taskId, progress });
    return result.task;
}

export async function getTasksByPriority(priority: 'low' | 'medium' | 'high' | 'urgent'): Promise<Task[]> {
    const result = await callTaskFunction('get_tasks_by_priority', { priority });
    return result.tasks;
}

export async function getTasksByAssignee(assignee: string): Promise<Task[]> {
    const result = await callTaskFunction('get_tasks_by_assignee', { assignee });
    return result.tasks;
}

export async function getTasksByCategory(category: string): Promise<Task[]> {
    const result = await callTaskFunction('get_tasks_by_category', { category });
    return result.tasks;
}

export async function updateTaskNotes(taskId: string, notes: string, clerkUserId?: string): Promise<Task> {
    const result = await callTaskFunction('update_task', {
        taskId,
        updates: { notes },
        clerkUserId
    });
    return result.task;
}